'use client'

import {defaultCountry, defaultLocaleId} from '@local/config/locales.mjs'
import {createContext} from 'react'

export const defaultShopifyCountry = {
	isoCode: defaultCountry!.id,
	currency: defaultCountry!.currency,
}

const LocaleContext = createContext({
	// localization data
	translations: new Map(),
	rewrites: new Map(),

	// shopify data
	availableCountries: [],
	country: defaultShopifyCountry,

	// current locale
	locale: defaultLocaleId,
})

export default LocaleContext
